export default __webpack_public_path__ + "static/media/b2b-logo.d6337b4a.svg";